// results reducer
const PUSH_NEW_RESULTS = 'PUSH_NEW_RESULTS'
const CLEAR_RESULTS = 'SET_RESULTS'

function results(state = [], action) {
    switch(action.type) {
        case PUSH_NEW_RESULTS:
            return [action.newResult, ...state]
        case CLEAR_RESULTS:
            return []
        default:
            return state
    }
}

function addResult(newResult) {
    return {
        type: PUSH_NEW_RESULTS,
        newResult
    }
}

function clearResults() {
    return {
        type: CLEAR_RESULTS
    }
}

function resultCreator(imageSetId, trueMatch, responseFromHuman, responseFromMachine) {
    return {
        imageId: imageSetId,
        response: responseFromHuman,
        responseFromMachine: responseFromMachine,
        match: trueMatch
    }
}

export { results, addResult, clearResults, resultCreator }



// WEBPACK FOOTER //
// ./src/reducers/results.js